import { useContext } from 'react'

import { AppInfoContext } from 'contexts/AppInfoContext'

export const useAppInfo = () => useContext(AppInfoContext)
